import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reviews-block',
  templateUrl: './reviews-block.component.html',
  styleUrls: ['./reviews-block.component.scss']
})
export class ReviewsBlockComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
